document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-select]').forEach((select) => select.addEventListener('change', (event) => {
    const form = select.closest('form'); const price = form?.querySelector('[data-product-price]');
    const variant = event.target.options[event.target.selectedIndex];
    if (price && variant.dataset.price) price.textContent = variant.dataset.price;
  }));
  const saved = new Set(JSON.parse(localStorage.getItem('svarnai-wishlist') || '[]'));
  document.querySelectorAll('[data-wishlist]').forEach((button) => {
    const handle = button.dataset.wishlist;
    button.classList.toggle('is-saved', saved.has(handle));
    button.textContent = saved.has(handle) ? '♥' : '♡';
    button.addEventListener('click', () => {
      saved.has(handle) ? saved.delete(handle) : saved.add(handle);
      localStorage.setItem('svarnai-wishlist', JSON.stringify([...saved]));
      button.classList.toggle('is-saved', saved.has(handle));
      button.textContent = saved.has(handle) ? '♥' : '♡';
    });
  });
  document.querySelectorAll('.section,.manifesto,.brand-story').forEach((element) => element.dataset.reveal = '');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.14 });
    document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
  } else { document.querySelectorAll('[data-reveal]').forEach((element) => element.classList.add('is-visible')); }
  const giftWrap = document.querySelector('[data-gift-wrap]');
  if (giftWrap?.dataset.giftWrapVariant) {
    const toggle = giftWrap.querySelector('input[type="checkbox"]');
    toggle?.addEventListener('change', async () => {
      const root = window.Shopify?.routes?.root || '/';
      const variantId = giftWrap.dataset.giftWrapVariant;
      const updateAttributes = async (value) => fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Gift wrap': value } }) });
      if (toggle.checked) {
        const cart = await fetch(root + 'cart.js').then((response) => response.json());
        if (!cart.items.some((item) => String(item.variant_id) === String(variantId))) {
          await fetch(giftWrap.dataset.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { 'Gift wrap': 'Yes' } }] }) });
        }
        await updateAttributes('Yes');
      } else {
        const cart = await fetch(root + 'cart.js').then((response) => response.json());
        const wrap = cart.items.find((item) => String(item.variant_id) === String(variantId));
        if (wrap) await fetch(giftWrap.dataset.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: wrap.key, quantity: 0 }) });
        await updateAttributes('');
      }
      window.location.reload();
    });
  }
});
